import { render, staticRenderFns } from "./CaseMenu.vue?vue&type=template&id=8e75328c&scoped=true&"
import script from "./CaseMenu.vue?vue&type=script&lang=js&"
export * from "./CaseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CaseMenu.vue?vue&type=style&index=0&id=8e75328c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e75328c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e75328c')) {
      api.createRecord('8e75328c', component.options)
    } else {
      api.reload('8e75328c', component.options)
    }
    module.hot.accept("./CaseMenu.vue?vue&type=template&id=8e75328c&scoped=true&", function () {
      api.rerender('8e75328c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menus/CaseMenu.vue"
export default component.exports